export type AspectRatioOption = {
  label: string;
  value: number | null;
  iconBoxClass: string;
};

export const CROP_TOLERANCE_PX = 2;

export const ASPECT_RATIOS: AspectRatioOption[] = [
  { label: 'Original', value: null, iconBoxClass: '' },
  { label: '1:1', value: 1, iconBoxClass: 'size-[18px]' },
  { label: '2:3', value: 2 / 3, iconBoxClass: 'w-[12px] h-[18px]' },
  { label: '3:2', value: 3 / 2, iconBoxClass: 'w-[18px] h-[12px]' },
  { label: '3:4', value: 3 / 4, iconBoxClass: 'w-[14px] h-[18px]' },
  { label: '4:3', value: 4 / 3, iconBoxClass: 'w-[18px] h-[15px]' },
  { label: '9:16', value: 9 / 16, iconBoxClass: 'w-[10px] h-[18px]' },
  { label: '16:9', value: 16 / 9, iconBoxClass: 'w-[18px] h-[10px]' },
];
